import { render, staticRenderFns } from "./qrCodeLogin.vue?vue&type=template&id=99d80e4e&scoped=true&"
import script from "./qrCodeLogin.vue?vue&type=script&lang=ts&"
export * from "./qrCodeLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d80e4e",
  null
  
)

export default component.exports